import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaWhatsapp,
  FaCcVisa,
  FaCcMastercard,
  FaCcPaypal,
  FaCcAmex,
  FaEnvelope,
  FaPhoneAlt,
} from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white font-bodyFont">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
          {/* ====== Brand Identity Section ====== */}
          <div className="md:col-span-2 lg:col-span-1">
            <h2 className="text-2xl font-bold font-tesla tracking-wider mb-4">
              Luggaelegacy
            </h2>
            <p className="text-gray-400 text-sm mb-6 pr-4">
              Crafting stylish and durable bags for the modern adventurer.
              Discover our collection of timeless designs made with premium
              materials.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-blue-500 transition-colors duration-300"
              >
                <FaFacebookF size={20} />
              </a>
              <a
                href="https://www.instagram.com/galaxybags_luggageworld"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-pink-500 transition-colors duration-300"
              >
                <FaInstagram size={22} />
              </a>
              <a
                href="https://wa.me/919714158490"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-green-500 transition-colors duration-300"
              >
                <FaWhatsapp size={22} />
              </a>
            </div>
          </div>

          {/* ====== Shop Section ====== */}
          <div>
            <h3 className="text-gray-400 font-semibold text-lg mb-6 uppercase tracking-wide">
              Shop
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/bags" className="text-gray-300 hover:text-white">
                  Bags
                </Link>
              </li>
              <li>
                <Link
                  to="/new-arrivals"
                  className="text-gray-300 hover:text-white"
                >
                  New Arrivals
                </Link>
              </li>
              <li>
                <Link to="/luggage" className="text-gray-300 hover:text-white">
                  Luggage
                </Link>
              </li>
              <li>
                <Link
                  to="/backpacks"
                  className="text-gray-300 hover:text-white"
                >
                  Backpacks
                </Link>
              </li>
            </ul>
          </div>

          {/* ====== Customer Care Section ====== */}
          <div>
            <h3 className="text-gray-400 font-semibold text-lg mb-6 uppercase tracking-wide">
              Support
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white">
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/returnandexchange"
                  className="text-gray-300 hover:text-white"
                >
                  Return & Exchange
                </Link>
              </li>
              <li>
                <Link
                  to="/privacypolicy"
                  className="text-gray-300 hover:text-white"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/termscondition"
                  className="text-gray-300 hover:text-white"
                >
                  Terms Of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* ====== Contact Section ====== */}
          <div>
            <h3 className="text-gray-400 font-semibold text-lg mb-6 uppercase tracking-wide">
              Contact Us
            </h3>
            <ul className="space-y-4 text-sm text-gray-300">
              <li className="flex items-center gap-3">
                <FaPhoneAlt />
                <a href="tel:+91 88661 52336" className="hover:text-white">
                  +91 88661 52336
                </a>
              </li>
              <li className="flex items-center gap-3">
                <FaEnvelope />
                <a
                  href="mailto:luggageworld2207@gmail.com"
                  className="hover:text-white"
                >
                  luggageworld2207@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* ====== Bottom Section ====== */}
        <div className="border-t border-gray-800 pt-8 mt-16">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear}{" "}
              <span className="font-tesla font-medium tracking-wider text-white">
                Luggaelegacy
              </span>
              . All rights reserved.
            </div>
            <div className="flex items-center gap-4 text-gray-300">
              <FaCcVisa size={32} title="Visa" />
              <FaCcMastercard size={32} title="Mastercard" />
              <FaCcPaypal size={32} title="Paypal" />
              <FaCcAmex size={32} title="American Express" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
